module.exports = __webpack_public_path__ + "img/yw_01.52d83bef.png";